<template>
  <div class="container">
		<div class="handle-container">
			<div class="search-container">
			</div>
			<div class="btn-style">
        <Button type="primary" icon="md-add" @click="openModal">添加变量</Button>
			</div>
		</div>
		<div class="table-container">
			<Table :columns="columns" :data="showVars">
				<template slot-scope="{ row }" slot="export">
					<span>{{ row.export ? '是' : '否' }}</span>	
				</template>
				<template slot-scope="{ row }" slot="action">
					<span class="edit-style" @click='handleEdit(row)'>编辑</span>
					<Poptip
						confirm
						title="确认要删除这条数据吗？"
						@on-ok="delVar(row.name)"
						transfer
					>
						<span class="del-style">删除</span>
					</Poptip>
        </template>
			</Table>
		</div>
		<div class="flex flex-justify-center">
			<Page :total="vars.length" :current.sync="page" :page-size="pageSize"/>
		</div>
		<var-modal v-model="showVarModal" @onSubmit="editVar" @onCancel="closeModal" :curVar="curVar"/>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import VarModal from './VarModal.vue'

export default {
	components: {
		VarModal,	
	},
  data() {
		return {
			showVarModal: false,
			curVar: undefined,
			columns: [
				{title: '变量名称', key: 'name'},
				{title: '变量类型', key: 'type'},
				{title: '变量初始值', key: 'value'},
				{title: '是否导出', slot: 'export'},
				{title: '操作', slot: 'action'},
			],
			pageSize: 20,
			page: 1,
		}
	},
	computed: {
    ...mapState('setting', [
			'vars',
    ]),
		showVars() {
			const startIndex = (this.page - 1) * this.pageSize;
			return this.vars?.slice(startIndex, startIndex + this.pageSize) || [];
		},
	},
	methods: {
    ...mapActions('setting', ['saveVar', 'delVar']),
		openModal() {
      this.showVarModal = true;
		},
		editVar(varInfo) {
			this.saveVar(varInfo)
		},
		handleEdit(varInfo) {
			this.curVar = { ...varInfo, id: varInfo.name };
      this.openModal();
		},
		closeModal() {
			this.curVar = undefined;
		}
	}
}
</script>
<style lang="scss" scoped>
.container{
	width: 100%;
	padding: 20px;
	background-color: #fff;
	.handle-container{
		width: 100%;
		display: flex;
		justify-content: space-between;
		.btn-style{
			display: flex;
			justify-items: flex-start;
			div{
				padding: 10px 20px;
				border-radius: 20px;
				font-size: 14px;
				color: #fff;
			}
			.add-style{
				background-color: #ffa800;
				margin-right: 10px;
			}
			.export-style{
				background-color: #6186cf;
			}
			i{
				font-size: 18px;
			}
		}
	}
	.table-container{
		padding: 20px 0;
	}
	.del-style{
		color: #e72e2e;
		
	}
	.edit-style{
		display: inline-block;
		color: #6186cf;
		padding-right: 20px;
	}
}
</style>